import initialize from "./initialize";
import { registerDecorator } from 'webpack-decorators';
import { decoratorOptions } from './configParams';
import reactDecorator from './decorators/react-decorator';
import reactDomDecorator from './decorators/react-dom-decorator';
let performanceItem = {};
let sent = false;

export const onClientEntry = (_, pluginOptions) => {
  const {
    clientDecoratorConfigParams = { apply: true, options: decoratorOptions.reactDom }
  } = pluginOptions;

  // register perf decorators
  if (clientDecoratorConfigParams.apply) {
    if (clientDecoratorConfigParams.options & decoratorOptions.react) {
      registerDecorator('react', reactDecorator, 'createElement');
    }
    if (clientDecoratorConfigParams.options & decoratorOptions.reactDom) {
      registerDecorator('react-dom', reactDomDecorator, 'render', 'hydrate');
    }
  }

  if (window.tracking && window.tracking.track) {
    sendWhenReady();
  } else {
    window.addEventListener("trackingReady", () => {
      sendWhenReady();
    });
  }
  window.addEventListener("unload", () => {
    if (!sent) {
      sendData();
    }
  });
};

const sendWhenReady = () => {
  const interval = setInterval(() => {
    try{
    if (!sent && collectData()) {
      sendData();
      sent = true;
      clearInterval(interval);
    }
    } catch(ex) {
      console.log(ex)
      clearInterval(interval)
    }
  }, 500);
};

const collectData = () => {
  const keys = Object.keys(performanceItem);
  if(!(keys.includes("ttfi") && keys.includes("fmp"))){
    if(!!window.performance && performance.getEntriesByType){
      performance.getEntriesByType('mark').forEach(perfEntry => {
        switch(perfEntry.name){
          case "reactHydrationStarted":
              if (!performanceItem.bundleStart) {
                performanceItem.bundleStart = perfEntry.startTime;
              }
              break;
            case "reactHydrationCompleted":
              if (!performanceItem.ttfi) {
                performanceItem.ttfi = perfEntry.startTime;
              }
              break;
            case "parseHeadStarted":
              if (!performanceItem.parseStart) {
                performanceItem.parseStart = perfEntry.startTime;
              }
              break;
            case "parseHeadCompleted":
              if (!performanceItem.headParseEnd) {
                performanceItem.headParseEnd = perfEntry.startTime;
              }
              break;
            case "first-meaningful-paint":
              if (!performanceItem.fmp) {
                performanceItem.fmp = perfEntry.startTime;
              }
              break;
            default:
              break;
          }
        })
    }
  }
  return keys.includes("ttfi") && keys.includes("fmp");
};

const sendData = () => {
  cleanData();
  performanceItem = { ...performanceItem, ...(initialize.receivePerformanceItem() || {}) };
  if (process.env.NODE_ENV == "production") {
    window.tracking.track(performanceItem.route, performanceItem);
  }
};

const cleanData = () => {
  if (performanceItem.fmp && performanceItem.fmp > 60000) {
    delete performanceItem.fmp;
  }
  if (performanceItem.ttfi && performanceItem.ttfi > 60000) {
    delete performanceItem.ttfi;
  }
};